import { render, staticRenderFns } from "./StartUpFeature.vue?vue&type=template&id=695af8a8&"
import script from "./StartUpFeature.vue?vue&type=script&lang=js&"
export * from "./StartUpFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports